import { getStore } from "./engine/plugins/BridgeStore"
import { setTokens } from "./engine/modules/session/actions/creators"

/**
 * Функции, использующиеся в автотестах
 */
const automatedTestUtils = {
  setTokens: ({ tokenType, token, refreshToken, expiresIn }) => {
    getStore().dispatch(setTokens(tokenType, token, refreshToken, expiresIn))
  },
}

window.__AUTOMATED_TEST_UTILS__ = automatedTestUtils
